import { fetchFilters } from './api/filters.api';
import { autoCompleteSearch, searchTemplates } from './api/template.api';
import { buildSearchQueryFromFilters, prepareTemplateFilters, processTemplateSearchAPIResponse, } from '../../../utils/templateGrid/template.util';
import { TEMPLATE_PAGE_SIZE } from '../../../constants/templateGrid';
import { parseFiltersFromQueryParams, parseSelectedFilters, } from '../../../utils/filters';
import { toggleFavourite } from '../../../utils/templateGrid/toggleFavourite';
const _fetchTemplates = async (dispatch, payload, append = false, isFavourite, state, dimension, isPurchased) => {
    dispatch({ type: 'templates-loading' });
    try {
        if (isFavourite) {
            payload.query.dimensions = dimension
                ? [dimension]
                : [state.selectedDimensionForFavourite];
            payload.query.favourites = true;
            payload.query.search_term = '';
        }
        else if (isPurchased) {
            payload.query.dimensions = dimension
                ? [dimension]
                : [state.selectedDimensionForPurchased];
            payload.query.purchased = true;
            payload.query.search_term = '';
        }
        const response = await searchTemplates(payload);
        const { templates, total_templates: total, offset, facets, } = processTemplateSearchAPIResponse(response);
        dispatch({
            type: 'templates-loaded',
            templates,
            total,
            offset: offset + TEMPLATE_PAGE_SIZE,
            append,
        });
        return facets;
    }
    catch (error) {
        console.error(error);
    }
};
export const refreshTemplates = async (dispatch, offset, filters, searchQuery, isFavourite, state, dimension, filterParentKey, isPurchased, enableUrlPersist) => {
    const query = buildSearchQueryFromFilters(TEMPLATE_PAGE_SIZE, offset, 'marketing', filters, searchQuery);
    const facets = await _fetchTemplates(dispatch, query, false, isFavourite, state, dimension, isPurchased);
    dispatch({
        type: 'templates-filters-loaded',
        filters: prepareTemplateFilters(filters, facets, filterParentKey, enableUrlPersist),
    });
};
export const loadMoreTemplates = async (dispatch, offset, filters, searchQuery, isFavourite, state) => {
    const query = buildSearchQueryFromFilters(TEMPLATE_PAGE_SIZE, offset, 'marketing', filters, searchQuery);
    await _fetchTemplates(dispatch, query, true, isFavourite, state);
};
export const fetchFiltersAndTemplates = async (dispatch, isFavourite, state, isPurchased, defaultFilters, enableUrlPersist, offset = 0) => {
    try {
        dispatch({ type: 'templates-filters-loading' });
        const filters = await fetchFilters();
        let { filters: parsedFilters, searchTerm } = parseFiltersFromQueryParams(filters);
        parsedFilters = parseSelectedFilters(filters, defaultFilters);
        const search_term = searchTerm || defaultFilters.searchTerm || '';
        const query = buildSearchQueryFromFilters(TEMPLATE_PAGE_SIZE, offset, 'marketing', parsedFilters, search_term);
        const facets = await _fetchTemplates(dispatch, query, false, isFavourite, state, undefined, isPurchased);
        dispatch({
            type: 'templates-filters-loaded',
            filters: prepareTemplateFilters(parsedFilters, facets),
        });
        dispatch({ type: 'search-query-updated', searchQuery: search_term });
    }
    catch (error) {
        console.error(error);
    }
};
export const toggleFavorite = async (dispatch, payload) => {
    await toggleFavourite(payload);
    dispatch({
        type: 'toggle-favourite',
        templateId: payload.template_id,
        status: payload.status,
    });
    return payload.status;
};
export const autoComplete = async (query) => {
    const suggestions = await autoCompleteSearch(query);
    return suggestions;
};
